import { render } from "./sidemenu.vue?vue&type=template&id=0428cc83&scoped=true"
import script from "./sidemenu.vue?vue&type=script&lang=js"
export * from "./sidemenu.vue?vue&type=script&lang=js"

import "./sidemenu.vue?vue&type=style&index=0&id=0428cc83&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0428cc83"

export default script